/**
 * Backend parameter names for global context parameters.
 * These match the parameter names expected by the backend reporting API.
 */
export const PARAM_NAMES = {
  PROJECT_ID: "ProjectId",
  TENANT_ID: "TenantId",
} as const;

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

/**
 * Default delivery GUIDs matching the C# backend defaults (ReportDelivery.cs).
 * Used when creating new report lists/items without explicit delivery configuration.
 */
export const DEFAULT_DELIVERY_TYPE_KEY = "86BB0A58-5F58-ED11-95D2-381428DF573C";
export const DEFAULT_FILE_TYPE_KEY = "2CCA3D38-625A-ED11-95D3-381428DF573C";
export const DEFAULT_COLLATION_TYPE_KEY = "D4EEB70F-EB59-ED11-95D3-381428DF573C";

/**
 * Returns the value if it's a non-empty, non-zero GUID; otherwise returns the fallback.
 * Handles undefined, null, empty string, and EMPTY_GUID.
 */
export function resolveGuid(value: string | undefined | null, fallback: string): string {
  if (!value || value === EMPTY_GUID) return fallback
  return value
}

export const MAX_CONCURRENT_PARAMETER_REQUESTS = 3;

/** Global parameter names that are excluded from list-defined parameters */
export const GLOBAL_PARAMETER_NAMES = [
  "tenantid",
  "projectid",
  "reporttypeclass",
  "componentid",
] as const;

/**
 * Global parameter names excluded from preview window parameter panel.
 * Similar to GLOBAL_PARAMETER_NAMES but allows reporttypeclass and componentid to be visible.
 * These match the backend parameter names (case-insensitive).
 */
export const PREVIEW_GLOBAL_PARAMETER_NAMES = [
  "tenantid",
] as const;

export const STORAGE_KEYS = {
  ACTIVE_PROJECT_ID: "activeProjectId",
  ACTIVE_TAB_INDEX: "activeTabIndex",
  OPEN_REPORT_LIST_TABS: "openReportListTabs",
  SHOW_REPORTS_LIBRARY: "showReportsLibrary",
  EXPANDED_FOLDERS: "expandedFolders",
  REPORT_LIBRARY_POSITION: "reportLibraryPosition",
  SHOW_DETAILS_PANEL: "showDetailsPanel",
} as const;

export const QUERY_PARAMS = {
  PROJECT_ID: "projectId",
} as const;
